export interface Vkforg {
  id: number;
  vkforg: string;
  kurzbezeichnung: string;
  idfirma: number;
}
